/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Swap_In_DraftInputs */

const en_us2_draft_swap_in_draft = /** @type {(inputs: Draft_Swap_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap in the draft`)
};

const pt_br2_draft_swap_in_draft = /** @type {(inputs: Draft_Swap_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar no rascunho`)
};

const es_419_draft_swap_in_draft = /** @type {(inputs: Draft_Swap_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar en el borrador`)
};

const pt_pt2_draft_swap_in_draft = /** @type {(inputs: Draft_Swap_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar no rascunho`)
};

const fr_fr2_draft_swap_in_draft = /** @type {(inputs: Draft_Swap_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer dans le brouillon`)
};

const de_de2_draft_swap_in_draft = /** @type {(inputs: Draft_Swap_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Entwurf tauschen`)
};

const it_it2_draft_swap_in_draft = /** @type {(inputs: Draft_Swap_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia nella bozza`)
};

/**
* | output |
* | --- |
* | "Swap in the draft" |
*
* @param {Draft_Swap_In_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_swap_in_draft = /** @type {((inputs?: Draft_Swap_In_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Swap_In_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_swap_in_draft(inputs)
	if (locale === "es-419") return es_419_draft_swap_in_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_swap_in_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_swap_in_draft(inputs)
	if (locale === "de-DE") return de_de2_draft_swap_in_draft(inputs)
	if (locale === "it-IT") return it_it2_draft_swap_in_draft(inputs)
	return en_us2_draft_swap_in_draft(inputs)
});
export { draft_swap_in_draft as "draft.swap_in_draft" }